import React from 'react';
import { Redirect, Route, useParams } from 'react-router-dom';

import { SPAM_MODERATION_ORGANIZATION_ID } from '../constants/moderation';

const ENTRY_POINTS = {
    attendees: 'events',
    events: 'attendees'
};

const ModerationRoute = ({ entryPoint, ...routeProps }) => {
    const { organizationId } = useParams();

    const redirectRules = [
        { condition: Number(organizationId) === SPAM_MODERATION_ORGANIZATION_ID, entryPoint: 'attendees' },
        { condition: Number(organizationId) !== SPAM_MODERATION_ORGANIZATION_ID, entryPoint: 'events' }
    ];

    const shouldRedirect = redirectRules.some(rule => rule.condition && entryPoint === rule.entryPoint);

    if (shouldRedirect) {
        const target = ENTRY_POINTS[entryPoint];
        if (target) {
            const url = window.location.pathname;
            const redirectUrl = url.replace(entryPoint, target);
            return <Route {...routeProps} render={() => <Redirect to={redirectUrl} />} />;
        }
    }

    return <Route {...routeProps} />;
};

export default ModerationRoute;
